'use strict';

exports.__esModule = true;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AppSubmenu = (_temp = _class = function (_Component) {
  _inherits(AppSubmenu, _Component);

  function AppSubmenu(props) {
    _classCallCheck(this, AppSubmenu);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {};
    return _this;
  }

  AppSubmenu.prototype.onMenuItemClick = function onMenuItemClick(event, item, index) {
    //avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    if (this.props.root && this.props.onRootItemClick) {
      this.props.onRootItemClick({
        originalEvent: event,
        item: item
      });
    } //execute command


    if (item.command) {
      item.command({
        originalEvent: event,
        item: item
      });
    } //prevent hash change


    if (item.items || !item.url) {
      event.preventDefault();
    }

    if (index === this.state.activeIndex) this.setState({
      activeIndex: null
    });else this.setState({
      activeIndex: index
    });

    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick({
        originalEvent: event,
        item: item
      });
    }
  };

  AppSubmenu.prototype.onMenuItemMouseEnter = function onMenuItemMouseEnter(index) {
    if (this.props.root && this.props.menuActive && this.isHorizontalOrSlim()) {
      this.setState({
        activeIndex: index
      });
    }
  };

  AppSubmenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.isHorizontalOrSlim() && prevProps.menuActive && !this.props.menuActive) {
      this.setState({
        activeIndex: null
      });
    }
  };

  AppSubmenu.prototype.isHorizontalOrSlim = function isHorizontalOrSlim() {
    return this.props.layoutMode === 'horizontal' || this.props.layoutMode === 'slim';
  };

  AppSubmenu.prototype.render = function render() {
    var _this2 = this;

    var items = this.props.items && this.props.items.map(function (item, i) {
      var active = _this2.state.activeIndex === i;
      var styleClass = (0, _classnames2.default)(item.badgeStyleClass, {
        'active-menuitem': active
      });

      var badge = item.badge && _react2.default.createElement('span', {
        className: 'menuitem-badge'
      }, item.badge);

      var submenuIcon = item.items && _react2.default.createElement('i', {
        className: 'fa fa-fw fa-angle-down menuitem-toggle-icon'
      });

      var tooltip = _this2.props.root && _react2.default.createElement('div', {
        className: 'layout-menu-tooltip'
      }, _react2.default.createElement('div', {
        className: 'layout-menu-tooltip-arrow'
      }), _react2.default.createElement('div', {
        className: 'layout-menu-tooltip-text'
      }, item.label));

      return _react2.default.createElement('li', {
        className: styleClass,
        key: i
      }, item.items && _this2.props.root === true && _react2.default.createElement('div', {
        className: 'arrow'
      }), _react2.default.createElement('a', {
        href: item.url,
        onClick: function onClick(e) {
          return _this2.onMenuItemClick(e, item, i);
        },
        target: item.target,
        onMouseEnter: function onMouseEnter(e) {
          return _this2.onMenuItemMouseEnter(i);
        }
      }, _react2.default.createElement('i', {
        className: item.icon
      }), _react2.default.createElement('span', null, item.label), submenuIcon, badge), tooltip, _react2.default.createElement(AppSubmenu, {
        items: item.items,
        onMenuItemClick: _this2.props.onMenuItemClick,
        layoutMode: _this2.props.layoutMode,
        menuActive: _this2.props.menuActive
      }));
    });
    return items ? _react2.default.createElement('ul', {
      className: this.props.className
    }, items) : null;
  };

  return AppSubmenu;
}(_react.Component), _class.defaultProps = {
  className: null,
  items: null,
  onMenuItemClick: null,
  onRootItemClick: null,
  root: false,
  layoutMode: null,
  menuActive: false
}, _temp);
AppSubmenu.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  items: _propTypes2.default.array,
  onMenuItemClick: _propTypes2.default.func,
  onRootItemClick: _propTypes2.default.func,
  root: _propTypes2.default.bool,
  layoutMode: _propTypes2.default.string,
  menuActive: _propTypes2.default.bool
} : {};
exports.default = AppSubmenu;
module.exports = exports['default'];